module.exports = {
          srcSet: __webpack_public_path__ + "images/1899-c3375755c227cf18ba89b75d77f788bb-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1899-2ac9d4fd08c5e18e9a21078a4e39433e-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1899-c3375755c227cf18ba89b75d77f788bb-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1899-2ac9d4fd08c5e18e9a21078a4e39433e-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1899-c3375755c227cf18ba89b75d77f788bb-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1899-c3375755c227cf18ba89b75d77f788bb-320.jpg"},
          
          width: 320,
          height: 251
        }